<p-panel>
  <app-reactive-form-builder #formbuilder (formChanges)="formChanges($event[0], $event[1])" (goBack)="goBack()"
    [form]="form.formFields" [serverUrl]="''" [dropdownLoadTrigger]="dropdownLoadTrigger" [dropdownsFinalized]="dropdownsFinalized" [id]="getModel().id"
    [request]="this.getType() === 1 ? this.analisisApi.analisis.PUT : this.analisisApi.analisis.POST"
    [getRequest]="this.analisisApi.analisis.GET">
  </app-reactive-form-builder>
</p-panel>

<p-dialog
  [(visible)]="form.openDialog"
  [modal]="true"
  [dismissableMask]="true"
  header="Añadir valor"
  [style]="{ width: '28rem' }"
>
  <div [formGroup]="comunidadForm" class="p-fluid">
    <div class="field">
      <label for="nombre">Nombre</label>
      <input
        id="nombre"
        pInputText
        formControlName="nombre"
      />
      <small
        *ngIf="comunidadForm.controls['nombre']?.invalid && comunidadForm.controls['nombre']?.touched"
        class="p-error"
      >
        Campo requerido
      </small>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="p-button-text" (click)="form.openDialog = false" label="Cancelar"></button>
    <button pButton type="button" (click)="saveNewOption()" label="Añadir" icon="pi pi-check"></button>
  </ng-template>
</p-dialog>